import React from 'react';
import { BsFillHouseGearFill } from 'react-icons/bs';
import { lazyPage } from '../lazyPage';

const FeatureManagement = lazyPage(() => import(/* webpackChunkName: "m-platform-admin" */ '../../pages/FeatureManagement'));

/** Feature Management — Platform Admin module. Identical to the previous legacy declaration. */
const featureMgmtManifest = {
    id: 'feature-mgmt',
    featureName: 'feature_mgmt',
    permission: 'view',
    routes: [{ path: '/feature-management', element: <FeatureManagement /> }],
    sidebarItems: [{ text: 'Feature Management', icon: <BsFillHouseGearFill />, link: '/feature-management' }],
};

export default featureMgmtManifest;
